import React from 'react';
import { Form, Message } from 'semantic-ui-react'
// import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

class VerParam2 extends React.Component { 
  state={
    argsDocum: {empresaRazonSocial: this.props.list.empresaRazonSocial?this.props.list.empresaRazonSocial:"",
                empresaNit: this.props.list.empresaNit?this.props.list.empresaNit:"",
                empresaWeb: this.props.list.empresaWeb?this.props.list.empresaWeb:"",
                empresaDir1: this.props.list.empresaDir1?this.props.list.empresaDir1:"",
                empresaTel1: this.props.list.empresaTel1?this.props.list.empresaTel1:"",
                empresaCel1: this.props.list.empresaCel1?this.props.list.empresaCel1:"",
                empresaCiudad1: this.props.list.empresaCiudad1?this.props.list.empresaCiudad1:"",
                empresaDir2: this.props.list.empresaDir2?this.props.list.empresaDir2:"",
                empresaTel2: this.props.list.empresaTel2?this.props.list.empresaTel2:"",
                empresaCel2: this.props.list.empresaCel2?this.props.list.empresaCel2:"",
                empresaCiudad2: this.props.list.empresaCiudad2?this.props.list.empresaCiudad2:"",
                empresaBanco1: this.props.list.empresaBanco1?this.props.list.empresaBanco1:"",
                empresaCuenta1: this.props.list.empresaCuenta1?this.props.list.empresaCuenta1:"",
                empresaBanco2: this.props.list.empresaBanco2?this.props.list.empresaBanco2:"",
                empresaCuenta2: this.props.list.empresaCuenta2?this.props.list.empresaCuenta2:"",
                empresaPresentacion: this.props.list.empresaPresentacion?this.props.list.empresaPresentacion:"",
                empresaNombreFirma: this.props.list.empresaNombreFirma?this.props.list.empresaNombreFirma:"",
                empresaCargoFirma: this.props.list.empresaCargoFirma?this.props.list.empresaCargoFirma:"",
                empresaMailFirma: this.props.list.empresaMailFirma?this.props.list.empresaMailFirma:"",
                empresaCelFirma: this.props.list.empresaCelFirma?this.props.list.empresaCelFirma:"",
                mensaje: this.props.list.mensaje?this.props.list.mensaje:"",
                generandoProg: this.props.list.generandoProg?this.props.list.generandoProg:"",
                trm: this.props.list.trm,
                mailFactura: this.props.list.mailFactura,
                mailFacturaPanama: this.props.list.mailFacturaPanama,
                medidaQR: this.props.list.medidaQR,
                minimoDolar: this.props.list.minimoDolar,
                maximoDolar: this.props.list.maximoDolar,
                rango1Desde: this.props.list.rango1Desde,
                rango1Hasta: this.props.list.rango1Hasta,
                rango2Hasta: this.props.list.rango2Hasta,
                rango3Hasta: this.props.list.rango3Hasta,
                _id: this.props.list._id?this.props.list._id:"",
                },
    confirmaAct: false,
    open: false,
  }

  handleChange = (ev) => {
    // console.log(this.props.permiteUpdate)
    // console.log(ev.target.name)
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      const argsDocum = this.state.argsDocum
      argsDocum[ev.target.name] = ev.target.value 
      this.setState({argsDocum});
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {argsDocum, open, confirmaAct} = this.state;

    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down white icon"></i>
          Parametros
        </button>

        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
            <h1 style={{color: 'black'}}>Generales</h1>

            <Form.Field>
              <div className="ui one column stackable grid">
                <div className="column" style={{width: '100%'}}>
                  <label style={this.props.styles.label}>Mensaje</label>
                  <input style={this.props.styles.input} autoComplete="off" name="mensaje" id="mensaje" value={this.props.permiteUpdate?argsDocum.mensaje:this.props.list.mensaje} onChange={this.handleChange} placeholder='Mensaje'/>
                </div>
              </div>
            </Form.Field>

            <hr></hr>
            <h1 style={{color: 'black'}}>Empresa</h1>

            <Form.Field>
              <div className="ui three column stackable grid">
                <div className="column" style={{width: '50%'}}>
                  <label style={this.props.styles.label}>Razón social</label>
                  <input autoComplete="off" name="empresaRazonSocial" id="empresaRazonSocial" value={this.props.permiteUpdate?argsDocum.empresaRazonSocial:this.props.list.empresaRazonSocial?this.props.list.empresaRazonSocial:""} onChange={this.handleChange} placeholder='Razón social'/>
                </div>
                <div className="column" style={{width: '15%'}}>
                  <label style={this.props.styles.label}>NIT</label>
                  <input autoComplete="off" name="empresaNit" id="empresaNit" value={this.props.permiteUpdate?argsDocum.empresaNit:this.props.list.empresaNit?this.props.list.empresaNit:""} onChange={this.handleChange} placeholder='NIT'/>
                </div>
                <div className="column" style={{width: '35%'}}>
                  <label style={this.props.styles.label}>Web</label>
                  <input autoComplete="off" name="empresaWeb" id="empresaWeb" value={this.props.permiteUpdate?argsDocum.empresaWeb:this.props.list.empresaWeb?this.props.list.empresaWeb:""} onChange={this.handleChange} placeholder='Web'/>
                </div>
              </div>
            </Form.Field>
            <Form.Field>
              <div className="ui four column stackable grid">
                <div className="column" style={{width: '50%'}}>
                  <label style={this.props.styles.label}>Dirección 1</label>
                  <input autoComplete="off" name="empresaDir1" id="empresaDir1" value={this.props.permiteUpdate?argsDocum.empresaDir1:this.props.list.empresaDir1?this.props.list.empresaDir1:""} onChange={this.handleChange} placeholder='Dirección'/>
                </div>
                <div className="column" style={{width: '17%'}}>
                  <label style={this.props.styles.label}>Ciudad 1</label>
                  <input autoComplete="off" name="empresaCiudad1" id="empresaCiudad1" value={this.props.permiteUpdate?argsDocum.empresaCiudad1:this.props.list.empresaCiudad1?this.props.list.empresaCiudad1:""} onChange={this.handleChange} placeholder='Ciudad 1'/>
                </div>
                <div className="column" style={{width: '17%'}}>
                  <label style={this.props.styles.label}>Teléfono 1</label>
                  <input autoComplete="off" name="empresaTel1" id="empresaTel1" value={this.props.permiteUpdate?argsDocum.empresaTel1:this.props.list.empresaTel1?this.props.list.empresaTel1:""} onChange={this.handleChange} placeholder='Teléfono 1'/>
                </div>                
                <div className="column" style={{width: '16%'}}>
                  <label style={this.props.styles.label}>Celular 1</label>
                  <input autoComplete="off" name="empresaCel1" id="empresaCel1" value={this.props.permiteUpdate?argsDocum.empresaCel1:this.props.list.empresaCel1?this.props.list.empresaCel1:""} onChange={this.handleChange} placeholder='Celular 1'/>
                </div>
              </div>
              <div className="ui four column stackable grid">
                <div className="column" style={{width: '50%'}}>
                  <label style={this.props.styles.label}>Dirección 2</label>
                  <input autoComplete="off" name="empresaDir2" id="empresaDir2" value={this.props.permiteUpdate?argsDocum.empresaDir2:this.props.list.empresaDir2?this.props.list.empresaDir2:""} onChange={this.handleChange} placeholder='Dirección 2'/>
                </div>
                <div className="column" style={{width: '17%'}}>
                  <label style={this.props.styles.label}>Ciudad 2</label>
                  <input autoComplete="off" name="empresaCiudad2" id="empresaCiudad2" value={this.props.permiteUpdate?argsDocum.empresaCiudad2:this.props.list.empresaCiudad2?this.props.list.empresaCiudad2:""} onChange={this.handleChange} placeholder='Ciudad 2'/>
                </div>
                <div className="column" style={{width: '17%'}}>
                  <label style={this.props.styles.label}>Teléfono 2</label>
                  <input autoComplete="off" name="empresaTel2" id="empresaTel2" value={this.props.permiteUpdate?argsDocum.empresaTel2:this.props.list.empresaTel2?this.props.list.empresaTel2:""} onChange={this.handleChange} placeholder='Teléfono 2'/>
                </div>                
                <div className="column" style={{width: '16%'}}>
                  <label style={this.props.styles.label}>Celular 2</label>
                  <input autoComplete="off" name="empresaCel2" id="empresaCel2" value={this.props.permiteUpdate?argsDocum.empresaCel2:this.props.list.empresaCel2?this.props.list.empresaCel2:""} onChange={this.handleChange} placeholder='Celular 2'/>
                </div>
              </div>            
            </Form.Field>

            <h1 style={{color: 'black'}}>Para documentos</h1>

            <Form.Field>
              <div className="ui four column stackable grid">
                <div className="column" style={{width: '25%'}}>
                  <label style={this.props.styles.label}>Banco 1</label>
                  <input autoComplete="off" name="empresaBanco1" id="empresaBanco1" value={this.props.permiteUpdate?argsDocum.empresaBanco1:this.props.list.empresaBanco1?this.props.list.empresaBanco1:""} onChange={this.handleChange} placeholder='Banco 1'/>
                </div>
                <div className="column" style={{width: '25%'}}>
                  <label style={this.props.styles.label}>Cuenta 1</label>
                  <input autoComplete="off" name="empresaCuenta1" id="empresaCuenta1" value={this.props.permiteUpdate?argsDocum.empresaCuenta1:this.props.list.empresaCuenta1?this.props.list.empresaCuenta1:""} onChange={this.handleChange} placeholder='Cuenta 1'/>
                </div>
                <div className="column" style={{width: '25%'}}>
                  <label style={this.props.styles.label}>Banco 2</label>
                  <input autoComplete="off" name="empresaBanco2" id="empresaBanco2" value={this.props.permiteUpdate?argsDocum.empresaBanco2:this.props.list.empresaBanco2?this.props.list.empresaBanco2:""} onChange={this.handleChange} placeholder='Banco 2'/>
                </div>                
                <div className="column" style={{width: '25%'}}>
                  <label style={this.props.styles.label}>Cuenta 2</label>
                  <input autoComplete="off" name="empresaCuenta2" id="empresaCuenta2" value={this.props.permiteUpdate?argsDocum.empresaCuenta2:this.props.list.empresaCuenta2?this.props.list.empresaCuenta2:""} onChange={this.handleChange} placeholder='Cuenta 2'/>
                </div>
              </div>
              <div className="ui four four stackable grid">
                <div className="column" style={{width: '25%'}}>
                  <label style={this.props.styles.label}>Nombre firma</label>
                  <input autoComplete="off" name="empresaNombreFirma" id="empresaNombreFirma" value={this.props.permiteUpdate?argsDocum.empresaNombreFirma:this.props.list.empresaNombreFirma?this.props.list.empresaNombreFirma:""} onChange={this.handleChange} placeholder='Nombre firma'/>
                </div>
                <div className="column" style={{width: '25%'}}>
                  <label style={this.props.styles.label}>Cargo firma</label>
                  <input autoComplete="off" name="empresaCargoFirma" id="empresaCargoFirma" value={this.props.permiteUpdate?argsDocum.empresaCargoFirma:this.props.list.empresaCargoFirma?this.props.list.empresaCargoFirma:""} onChange={this.handleChange} placeholder='Cargo firma'/>
                </div>
                <div className="column" style={{width: '25%'}}>
                  <label style={this.props.styles.label}>Mail firma</label>
                  <input autoComplete="off" name="empresaMailFirma" id="empresaMailFirma" value={this.props.permiteUpdate?argsDocum.empresaMailFirma:this.props.list.empresaMailFirma?this.props.list.empresaMailFirma:""} onChange={this.handleChange} placeholder='Mail firma'/>
                </div>     
                <div className="column" style={{width: '25%'}}>
                  <label style={this.props.styles.label}>Celular firma</label>
                  <input autoComplete="off" name="empresaCelFirma" id="empresaCelFirma" value={this.props.permiteUpdate?argsDocum.empresaCelFirma:this.props.list.empresaCelFirma?this.props.list.empresaCelFirma:""} onChange={this.handleChange} placeholder='Celular firma'/>
                </div>                
              </div>            
            </Form.Field>

            <h1 style={{color: 'black'}}>Otros</h1>
            <Form.Field>
              <div className="ui five column stackable grid">
                <div className="column" style={{width: '20%'}}>
                  <label style={this.props.styles.label}>Mail notificación factura de Colombia</label>
                  <input autoComplete="off" name="mailFactura" id="mailFactura" value={this.props.permiteUpdate?argsDocum.mailFactura:this.props.list.mailFactura?this.props.list.mailFactura:""} onChange={this.handleChange} placeholder='Mail factura Colombia'/>
                </div>
                <div className="column" style={{width: '20%'}}>
                  <label style={this.props.styles.label}>Mail notificación factura de Panamá</label>
                  <input autoComplete="off" name="mailFacturaPanama" id="mailFacturaPanama" value={this.props.permiteUpdate?argsDocum.mailFacturaPanama:this.props.list.mailFacturaPanama?this.props.list.mailFacturaPanama:""} onChange={this.handleChange} placeholder='Mail factura Panamá'/>
                </div>
                <div className="column" style={{width: '20%'}}>
                  <label style={this.props.styles.label}>TRM actual</label>
                  <input autoComplete="off" name="trm" id="trm" value={this.props.permiteUpdate?argsDocum.trm:this.props.list.trm?this.props.list.trm:""} onChange={this.handleChange} placeholder='TRM'/>
                </div>                
                <div className="column" style={{width: '20%'}}>
                  <label style={this.props.styles.label}>Mínimo valor del Dolar</label>
                  <input type='number' step="1" min="1" autoComplete="off" name="minimoDolar" id="minimoDolar" value={this.props.permiteUpdate?argsDocum.minimoDolar:this.props.list.minimoDolar?this.props.list.minimoDolar:1} onChange={this.handleChange} placeholder='Mínimo valor del Dolar'/>
                </div>
                <div className="column" style={{width: '20%'}}>
                  <label style={this.props.styles.label}>Máximo valor del Dolar</label>
                  <input type='number' step="1" min="1" autoComplete="off" name="maximoDolar" id="maximoDolar" value={this.props.permiteUpdate?argsDocum.maximoDolar:this.props.list.maximoDolar?this.props.list.maximoDolar:1} onChange={this.handleChange} placeholder='Máximo valor del Dolar'/>
                </div>
              </div>
              <div className="ui five column stackable grid">
                <div className="column" style={{width: '20%'}}>
                  <label style={this.props.styles.label}>Tamaño del código QR</label>
                  <input type='number' step="2" min="2" max="4" autoComplete="off" name="medidaQR" id="medidaQR" value={this.props.permiteUpdate?argsDocum.medidaQR:this.props.list.medidaQR?this.props.list.medidaQR:2} onChange={this.handleChange} placeholder='Medida QR'/>
                </div>
                <div className="column" style={{width: '20%'}}>
                  <label style={this.props.styles.label}>Rango 1 para comisión - Desde</label>
                  <input type='number' step="0.01" min="1" autoComplete="off" name="rango1Desde" id="rango1Desde" value={this.props.permiteUpdate?argsDocum.rango1Desde:this.props.list.rango1Desde?this.props.list.rango1Desde:0} onChange={this.handleChange} placeholder='Rango 1 para comisión - Desde'/>
                </div>
                <div className="column" style={{width: '20%'}}>
                  <label style={this.props.styles.label}>Rango 1 para comisión - Hasta</label>
                  <input type='number' step="0.01" min="1" autoComplete="off" name="rango1Hasta" id="rango1Hasta" value={this.props.permiteUpdate?argsDocum.rango1Hasta:this.props.list.rango1Hasta?this.props.list.rango1Hasta:0} onChange={this.handleChange} placeholder='Rango 1 para comisión - Hasta'/>
                </div>
                <div className="column" style={{width: '20%'}}>
                  <label style={this.props.styles.label}>Rango 3 para comisión - Hasta</label>
                  <input type='number' step="0.01" min="1" autoComplete="off" name="rango2Hasta" id="rango2Hasta" value={this.props.permiteUpdate?argsDocum.rango2Hasta:this.props.list.rango2Hasta?this.props.list.rango2Hasta:0} onChange={this.handleChange} placeholder='Rango 2 para comisión - Hasta'/>
                </div>     
                <div className="column" style={{width: '20%'}}>
                  <label style={this.props.styles.label}>Rango 3 para comisión - Hasta</label>
                  <input type='number' step="0.01" min="1" autoComplete="off" name="rango3Hasta" id="rango3Hasta" value={this.props.permiteUpdate?argsDocum.rango3Hasta:this.props.list.rango3Hasta?this.props.list.rango3Hasta:0} onChange={this.handleChange} placeholder='Rango 3 para comisión - Hasta'/>
                </div>                
              </div>            
            </Form.Field>

            <Form.Field>
              <label style={this.props.styles.label}>Parrafo de presentación</label>
              <textarea name="empresaPresentacion" id="empresaPresentacion" 
                value={this.props.permiteUpdate?argsDocum.empresaPresentacion:this.props.list.empresaPresentacion?this.props.list.empresaPresentacion:""} 
                onChange={this.handleChange}>
              </textarea>
            </Form.Field>            
            <hr></hr>

            <EstaSeguro permiteUpdate={this.props.permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
            {
              this.props.errors.length?<Message negative header="Los siguientes errores:"
              list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
            }
          </Form>
        </div>
      </div>
    )
  }
}

export default VerParam2
